import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FlightTypeIcon } from './../../../model/flights';
import { environment } from './../../environments/environment.dev';

@Injectable({
    providedIn: 'root'
})
export class IconService {
    constructor(private readonly matIconRegistry: MatIconRegistry, private readonly domSanitizer: DomSanitizer) {}

    public registerIcons() {
        Object.values(FlightTypeIcon).forEach(key => {
            this.matIconRegistry.addSvgIcon(
                key,
                this.domSanitizer.bypassSecurityTrustResourceUrl(`${environment.deployUrl}assets/svg/icons/${key}.svg`)
            );
        });
    }
}
